export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-slate-300">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-24 sm:py-32">
        <h1 className="text-4xl font-bold text-white font-['Clash_Display'] mb-2">Privacy Policy</h1>
        <p className="text-slate-500 text-sm mb-12">Effective Date: 4/4/2026</p>

        <p className="mb-12 text-slate-400 leading-relaxed">
          Tegos Digital ("we," "our," or "us") operates a website that provides information about our services, including web design, AI automation, and digital solutions. This Privacy Policy explains how we collect, use, and protect your information.
        </p>

        <Section title="1. Information We Collect">
          <p className="mb-4">We may collect the following types of information:</p>
          <h3 className="text-white font-semibold mb-2">a. Information You Provide</h3>
          <ul className="list-disc list-inside space-y-1 mb-6 text-slate-400">
            <li>Name</li>
            <li>Email address</li>
            <li>Message content submitted through our contact form</li>
            <li>Information submitted via Calendly (e.g., scheduling details)</li>
          </ul>
          <h3 className="text-white font-semibold mb-2">b. Automatically Collected Information</h3>
          <ul className="list-disc list-inside space-y-1 mb-4 text-slate-400">
            <li>IP address</li>
            <li>Browser type</li>
            <li>Device information</li>
            <li>Pages visited and time spent on our site</li>
          </ul>
          <p>This data helps us improve our website and user experience.</p>
        </Section>

        <Section title="2. How We Use Your Information">
          <p className="mb-4">We use your information to:</p>
          <ul className="list-disc list-inside space-y-1 mb-4 text-slate-400">
            <li>Respond to inquiries and messages</li>
            <li>Schedule and manage consultations via Calendly</li>
            <li>Provide and improve our services</li>
            <li>Communicate with you regarding your request</li>
            <li>Analyze website performance and usage</li>
          </ul>
          <p>We do <strong className="text-white">not</strong> sell your personal information.</p>
        </Section>

        <Section title="3. Third-Party Services">
          <p className="mb-4">We may use trusted third-party services, including:</p>
          <ul className="list-disc list-inside space-y-1 mb-4 text-slate-400">
            <li><strong className="text-white">Calendly</strong> (for scheduling meetings)</li>
            <li><strong className="text-white">Email providers</strong> (for communication)</li>
          </ul>
          <p>These services may collect and process your data according to their own privacy policies.</p>
        </Section>

        <Section title="4. Data Protection">
          <p>We take reasonable measures to protect your information from unauthorized access, disclosure, or misuse. However, no method of transmission over the internet is 100% secure.</p>
        </Section>

        <Section title="5. Your Rights">
          <p className="mb-4">Depending on your location, you may have the right to:</p>
          <ul className="list-disc list-inside space-y-1 mb-4 text-slate-400">
            <li>Request access to your personal data</li>
            <li>Request correction or deletion</li>
            <li>Withdraw consent to data usage</li>
          </ul>
          <p>To exercise these rights, contact us at: <a href="mailto:tegosdigital@gmail.com" className="text-blue-400 hover:text-blue-300">tegosdigital@gmail.com</a></p>
        </Section>

        <Section title="6. Cookies">
          <p>We may use cookies or similar technologies to enhance your browsing experience. You can disable cookies in your browser settings.</p>
        </Section>

        <Section title="7. Changes to This Policy">
          <p>We may update this Privacy Policy at any time. Updates will be posted on this page with a revised effective date.</p>
        </Section>

        <Section title="8. Contact Us" last>
          <p className="mb-2">If you have any questions, contact us at:</p>
          <p>Email: <a href="mailto:tegosdigital@gmail.com" className="text-blue-400 hover:text-blue-300">tegosdigital@gmail.com</a></p>
        </Section>

        <p className="mt-12 pt-8 border-t border-[#1F1F22] text-slate-500 text-sm">
          By using our website, you agree to this Privacy Policy.
        </p>
      </div>
    </div>
  );
};

const Section = ({ title, children, last }) => (
  <div className={`mb-10 pb-10 ${!last ? 'border-b border-[#1F1F22]' : ''}`}>
    <h2 className="text-2xl font-bold text-white font-['Clash_Display'] mb-4">{title}</h2>
    <div className="text-slate-400 leading-relaxed space-y-2">{children}</div>
  </div>
);
